module.exports = __webpack_public_path__ + "static/media/33.1be4c607.jpg";